import { Injectable } from '@angular/core';
import { DataTableEditorService } from '../../search/results/data-table-editor.service';
import { SearchableEntityDataService } from './searchable-entity-data.service';
import { SearchableEntityBackendService } from './searchable-entity-backend.service';
import { SharedServiceRegistry } from '../../shared-service-registry';
import { CoreServiceRegistry } from '../../../core/core-service-registry';
import { PropertyChangeEvent } from '../../models/property-change-event';
import { SearchableEntityActionService } from './searchable-entity-action.service';

@Injectable()
export class SearchableEntityDataEditorService extends DataTableEditorService {

  protected backendService: SearchableEntityBackendService;
  protected dataService: SearchableEntityDataService;
  protected actionService: SearchableEntityActionService;

  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry) {
    super(coreServiceRegistry, sharedServiceRegistry);
  }

  public setDependentServices(dataService, backendService, actionService) {
    this.dataService = dataService;
    this.backendService = backendService;
    this.actionService = actionService;
  }

  /**
   * This method handles the changes to the property value
   * @param event - Property Change Event
   */
  public propertyValueChanged(event: PropertyChangeEvent): boolean {
    return true;
  }
  /**
   * This method is used to refresh the cells of the table
   * @param params - cell params
   */
  public refreshCells(params: any) {
    params.api.refreshCells({ force: true });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/services/searchable-entity/searchable-entity-data-editor.service.ts